import {PopupInterface} from "./interfaces/PopupInterface";

export class Popup implements PopupInterface {
    id = '';
    type = 'info';
    deepLink = undefined;
    text = '';
    title = '';
    createdAt = 0;
    hidding = true;
    showTimeInMilliseconds = 10 * 1000;

    constructor(data: PopupInterface) {
        Object.assign(this, data);
        this.createdAt = Date.now();
        this.id = Math.random().toString(36).substr(2, 9);
    }
}
